import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import "./page.css";
import "./Genuine.css";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  InputLabel,
} from "@material-ui/core";
import ContestService from "../services/ContestService";
import Loader from "../components/Loader";
import RCBContest from "../assets/RCBContest.jpg";
import ContestBannerImage from "./../assets/Contest Banner.jpg";
import Congratulation from "./../assets/Congratulation.jpg";
import LoginService from "../services/LoginService";
import BrandService from "../services/BrandService";

const Genuine = () => {
  const loginService = new LoginService();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [feedbackData, setfeedbackData] = useState({
    Username: "",
    email: "",
    MobNo: "",
    REMARK: "",
  });
  const [contestForm, setContestForm] = useState({
    email: "",
    question: { questionId: -1, optionId: -1 },
  });
  const [contestFormErrors, setContestFormErrors] = useState({
    email: "",
    question: "",
  });
  const [formErrors, setFormErrors] = useState({
    Username: "",
    email: "",
    MobNo: "",
    REMARK: "",
  });
  const [detail, setDetail] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogTnC, setShowDialogTnC] = useState(false);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(-1);
  const [questions, setQuestions] = useState([]);
  const [tncChecked, setTnCChecked] = useState(false);
  const [consentChecked, setConsentChecked] = useState(false);
  const [selectedQuestionAnswer, setSelectedQuestionAnswer] = useState({
    questionId: -1,
    optionId: -1,
  });
  const [email, setEmail] = useState([]);
  const location = useLocation();
  const ResData = location.state?.ResponseData || [];
  const [isQRScanned, setIsQRScanned] = useState(
    ResData.length == 0 ? true : false,
  );
  const ResponseQRScratch = location.state?.ResQRScratch || [];
  const mobileNo = location.state?.mobileNo || "";
  const brandId = location.state?.brandId || 0;
  const [formdata, setFormdata] = useState({
    seqNo: ResData.seqNo,
    responseCode: "",
    responseMessage: "",
    responseData: "",
    ProductName: "",
    scratch_code: "",
    BatchCode: "",
    MfgDate: "",
    verificationLogId: ResponseQRScratch.id,
    brandId: brandId,
  });
  const contestService = new ContestService();
  const brandService = new BrandService();
  const [isIPLContestRegister, setIsIPLContestRegister] = useState(false);
  const [isIPLContestEligible, setIsIPLContestEligible] = useState(false);
  const [isIPL2ContestEligible, setIsIPL2ContestEligible] = useState(false);
  const [isTooManyRegistration, setIsTooManyRegistration] = useState(false);
  const [isIPLContestEnabled, setIsIPLContestEnabled] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [showIframe, setShowIframe] = useState(false);
  const [brand, setBrand] = useState("");
  const [responseToken, setResponseToken] = useState("");

  const openDialog = () => {
    setShowDialog(true);
  };

  const closeDialog = () => {
    setShowDialog(false);
  };

  const openDialogTnC = () => {
    setShowDialogTnC(true);
  };

  const closeDialogTnC = () => {
    setShowDialogTnC(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    let isfrmvalid = true;
    let checkerror = formErrors;
    Object.entries(checkerror).map(([key, value]) => {
      const val = feedbackData[key];
      let valid = validateForm(key, val);
      if (!valid) {
        setFormErrors(checkerror);
        isfrmvalid = false;
      }
      return isfrmvalid;
    });

    if (isfrmvalid) {
      try {
        setLoading(true);
        const obj = {
          Username: feedbackData.Username,
          email: feedbackData.email,
          Mobno: feedbackData.MobNo,
          feedback: feedbackData.REMARK,
          ProductName: detail.name,
          verificationLogId: formdata.verificationLogId,
          brandId: formdata.brandId,
        };

        loginService.CreateFeedback(obj).then((response) => {
          setLoading(false);

          if (response.responseCode === "200") {
            toast.success("Feedback Submit Successfully!");
            setfeedbackData({
              Username: "",
              email: "",
              MobNo: "",
              REMARK: "",
            });
            closeDialog();
          } else if (response.responseCode === "400") {
            toast.error(response.responseMessage);
          }
        });
      } catch (error) {
        setLoading(false);
        console.error("Feedback failed:", error);
        toast.error(error.message);
      }
    }
  };

  const handleDialogClose = () => {
    setShowDialog(false);
    setfeedbackData({
      Username: "",
      email: "",
      MobNo: "",
      REMARK: "",
    });
    setFormErrors({
      Username: "",
      email: "",
      MobNo: "",
      REMARK: "",
    });
  };

  const handleFormChange = (event) => {
    const { name, value, checked, type } = event.target;
    setfeedbackData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "checkbox" ? checked : value,
    }));
    validateForm(name, value);
  };

  const validateForm = (name, value) => {
    setfeedbackData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    const errors = formErrors;
    let IsValid = true;
    switch (name) {
      case "Username":
        if (value.length < 1) {
          IsValid = false;
          errors.Username = "Please enter username.";
        } else errors.Username = "";
        break;
      case "email":
        if (value.length < 1) {
          IsValid = false;
          errors.email = "Please enter Email Address.";
        } else if (value.length >= 1) {
          /* eslint-disable */
          if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            IsValid = false;
            errors.email = "Please enter valid Email Address.";
          } else errors.email = "";
          /* eslint-enable */
        } else errors.email = "";
        break;
      case "MobNo":
        if (value.length < 1) {
          IsValid = false;
          errors.MobNo = "Please enter mobile no.";
        } else if (value.length >= 1) {
          if (!value.match(/^[6-9]\d{9}$/)) {
            IsValid = true;
            errors.MobNo = "Please enter valid mobile no.";
          } else errors.MobNo = "";
        } else errors.MobNo = "";
        break;
      case "REMARK":
        if (value.length < 1) {
          IsValid = false;
          errors.REMARK = "Please enter remarks.";
        } else errors.REMARK = "";
        break;
      default:
        break;
    }

    setFormErrors(errors);
    return IsValid;
  };

  const handleContestFormChange = (event) => {
    const { name, value } = event.target;
    validateContestForm(name, value);
    setContestForm((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const validateContestForm = (name, value) => {
    setContestForm((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    const errors = contestFormErrors;
    let IsValid = true;
    switch (name) {
      case "email":
        if (value.length < 1) {
          IsValid = false;
          errors.email = "Please enter Email Address.";
        } else if (value.length >= 1) {
          /* eslint-disable */
          if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            IsValid = false;
            errors.email = "Please enter valid Email Address.";
          } else errors.email = "";
          /* eslint-enable */
        } else errors.email = "";
        break;
      case "question":
        if (value != null && value.questionId === -1 && value.optionId === -1) {
          IsValid = false;
          errors.question = "Please Answer the Question before Submitting.";
        } else errors.question = "";
        break;
      default:
        break;
    }

    setContestFormErrors(errors);
    return IsValid;
  };

  const SaveContestDetails = (e) => {
    e.preventDefault();
    let isfrmvalid = true;
    let checkerror = contestFormErrors;
    Object.entries(checkerror).map(([key, value]) => {
      const val = contestForm[key];
      let valid = validateContestForm(key, val);
      if (!valid) {
        setContestFormErrors(checkerror);
        isfrmvalid = false;
      }
      return isfrmvalid;
    });

    if (isfrmvalid) {
      const obj = {
        verificationId: ResponseQRScratch.id,
        email: contestForm.email,
        questionId: contestForm.question.questionId,
        answerId: selectedQuestionAnswer.optionId,
        mobileNo: mobileNo,
        seqNo: formdata.seqNo,
      };
      setLoading(true);
      contestService.InsertContestUserDetails(obj).then((data) => {
        if (data.responseCode === "200") {
          navigate("/thank-you");
          setLoading(false);
        } else {
          setLoading(false);
        }
      });
    }
  };

  const GetQuestions = () => {
    setLoading(true);
    contestService.GetQuestions().then((data) => {
      if (data.responseCode === "200") {
        setQuestions(data.responseData);
        setLoading(false);
      } else {
        setQuestions([]);
        setLoading(false);
      }
    });
  };
  const onPlayNow = async () => {
    try {
      setLoading2(true);

      const obj = {
        verificationId: ResponseQRScratch.id,
      };

      const response = await contestService.GetContestToken(obj.verificationId);
      if (response.responseCode === "200") {
        setResponseToken(response.responseData.token);
        setShowIframe(true);
      } else if (response.responseCode === "401") {
        toast.error(response.responseMessage);
        setShowIframe(false);
        setResponseToken("");
      } else {
        toast.error(response.responseMessage);
        setShowIframe(false);
        setResponseToken("");
      }
    } catch (error) {
      toast.error(error.message || "Unexpected error occurred");
      setShowIframe(false);
    } finally {
      setLoading2(false);
    }
  };

  useEffect(() => {
    const CheckForContest = () => {
      setLoading(true);
      const obj = {
        mobileNo: mobileNo,
        seqNo: formdata.seqNo,
        brandId: brandId,
      };
      contestService.CheckForContest(obj).then((data) => {
        if (data.responseCode === "200" && data.ipL2Eligible != 1) {
          setIsIPLContestEnabled(true);
          setIsIPLContestRegister(false);
          setIsIPLContestEligible(true);
          setIsTooManyRegistration(false);
          setIsIPL2ContestEligible(false);
          GetQuestions();
          setLoading(false);
        } else if (data.responseCode === "200" && data.ipL2Eligible == 1) {
          setIsIPLContestEnabled(false);
          setIsIPLContestRegister(true);
          setIsIPLContestEligible(false);
          setIsIPL2ContestEligible(true);
          setIsTooManyRegistration(false);
          setLoading(false);
        } else if (data.responseCode === "201") {
          setIsIPLContestEnabled(true);
          setIsIPLContestRegister(true);
          setIsIPLContestEligible(false);
          setIsIPL2ContestEligible(false);
          setIsTooManyRegistration(false);
          setLoading(false);
        } else if (data.responseCode === "202") {
          setIsIPLContestEnabled(true);
          setIsIPLContestRegister(true);
          setIsIPLContestEligible(false);
          setIsIPL2ContestEligible(false);
          setIsTooManyRegistration(true);
          setLoading(false);
        } else {
          setIsIPLContestEnabled(false);
          setIsIPLContestRegister(true);
          setIsIPLContestEligible(false);
          setIsIPL2ContestEligible(false);
          setIsTooManyRegistration(false);
          setLoading(false);
        }
      });
    };
    const fetchBrandName = async (brandId) => {
      try {
        const data = await brandService.GetBrandName(brandId);
        if (data.responseCode === "200") {
          setBrand(data.responseData);
        }
      } catch (error) {
        console.error("Error fetching brand list:", error);
      }
    };
    CheckForContest();
    fetchBrandName(brandId);
    // //console.log('ANOTHER COMPONENT DATA: ', Data);
    setTimeout(() => {
      setLoading(false); // Data has loaded, set loading to false
    }, 1000);
    //getProductDetails();
    // const parameterValue = ResponseQRScratch.qrCode.split('?')[1].split('=')[1];
    // navigate(`/pa?U=${parameterValue}`);
    //console.log('DATA of ResData: ', ResData);
    //console.log('DATAof ResponseQRScratch', ResponseQRScratch);
    //navigate(`/pa?U=${parameterValue}`);
  }, []);

  // useEffect(() => {
  //
  //     const mountedCount = parseInt(localStorage.getItem('mountedCount'), 10) || 0;
  //     localStorage.setItem('mountedCount', mountedCount + 1);

  // },
  //   []);

  // useEffect(() => {
  //
  //   const mountedCount = parseInt(localStorage.getItem('mountedCount'), 10) || 0;
  //   if (mountedCount === 2 || mountedCount > 2) {
  //     const parameterValue = ResponseQRScratch.qrCode.split('?')[1].split('=')[1];
  //     //console.log(parameterValue);
  //     navigate(`/pa?U=${parameterValue}`);
  //     localStorage.setItem('mountedCount', 0); // Reset the count to 0
  //   }
  // }, [navigate, ResponseQRScratch.qrCode]);

  return loading ? (
    <Loader />
  ) : showIframe && responseToken ? (
    <div style={{ width: "100vw", height: "100vh" }}>
      <iframe
        src={`https://optimumnutritionxrcb.com/?token=${responseToken}`}
        allow="camera; gyroscope; accelerometer; magnetometer; xr-spatial-tracking;"
        title="Contest Game"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        allowFullScreen
      />
    </div>
  ) : (
    <>
      <div
        hidden={
          (!isIPLContestEnabled ?? isIPLContestRegister == false)
            ? true
            : isIPLContestEligible
        }
        className="container genuine"
      >
        <div className="row slidere-bg animate-in-down text-center">
          <div className="text-center banner-img">
            <img src={ContestBannerImage} />
          </div>
        </div>
      </div>
      <div className=" mt-2">
        <div className="container genuine">
          {ResData.length !== 0 ? (
            <div className="card mb-2">
              {ResponseQRScratch.scanCount > 0 ? (
                <div
                  hidden={!isIPLContestRegister}
                  className="card-header genuine-product"
                >
                  <p className="pa-text">
                    Dear Customer,{" "}
                    <span hidden={!isTooManyRegistration}>
                      you have reached your limit of contest participation. Your
                      previous entries have been recorded and we will notify you
                      if you have been chosen as the winner.
                    </span>{" "}
                    Looks like the code has already been used for authentication
                    on {ResponseQRScratch.scannedDate} on mobile{" "}
                    {ResponseQRScratch.mobileNumber}
                    <span
                      hidden={
                        (!isIPLContestEnabled ??
                        isTooManyRegistration == false ??
                        isIPLContestRegister == false)
                          ? true
                          : isIPLContestEligible
                      }
                    >
                      {" "}
                      and you have already participated in the contest.
                    </span>
                    {/* Did you try to check authenticity of your favorite Optimum Nutrition Product earlier?
                        If not or in case you need more information please connect with our customer care team on */}
                  </p>
                  <p className="pa-text">
                    <b> If this is not you,</b> please connect with our customer
                    care team on{" "}
                    <a href="mailto:Indiacustomercare@glanbia.com">
                      <u>Indiacustomercare@glanbia.com</u>
                    </a>{" "}
                    or{" "}
                    <a href="tel:01149594959">
                      <u>011-49594959</u>
                    </a>
                    .
                  </p>
                </div>
              ) : (
                <div
                  hidden={!isIPLContestRegister}
                  className="card-header genuine-product"
                >
                  Congratulations! Your {brand} product is Genuine and 100%
                  Authentic.
                  <span
                    style={{ display: "block" }}
                    hidden={!isTooManyRegistration}
                  >
                    Dear Customer, you have reached your limit of contest
                    participation. Your previous entries have been recorded and
                    we will notify you if you have been chosen as the winner.
                  </span>
                </div>
                // Congratulations! Your Optimum Nutrition product is 100% Authentic
              )}
              <hr hidden={!isIPLContestRegister}></hr>
              <div hidden={!isIPLContestRegister} className="row m-2">
                <div
                  hidden={isIPL2ContestEligible}
                  className="col-lg-6 left-side-product-box pb-3"
                >
                  <img
                    className="d-block img-fluid border p-3"
                    src={ResData?.productimage}
                    alt="genuine"
                    loading="lazy"
                  />
                </div>
                <div
                  hidden={!isIPL2ContestEligible}
                  className="col-lg-6 left-side-product-box pb-3 "
                >
                  <img
                    className="d-block border p-3"
                    src={Congratulation}
                    alt="genuine"
                    loading="lazy"
                  />
                </div>

                <div className="col-lg-6 name">
                  {isIPL2ContestEligible && (
                    <div className="col-lg-12 mb-3 my-md-4 text-center">
                      <button
                        className="play-now-btn"
                        type="button"
                        onClick={onPlayNow}
                        disabled={loading2}
                      >
                        {loading2 ? "Loading..." : "▶ Play Now"}
                      </button>
                    </div>
                  )}
                  <div className="right-side-pro-detail border p-3 m-0">
                    <div className="row">
                      <div className="col-lg-12">
                        <p className="m-0 p-0 price-pro">Product Name </p>
                        <a href>{ResData?.name}</a>
                        <hr className="m-0 pt-2 mt-2" />
                      </div>
                      <hr className="m-0 pt-2 mt-2" />
                      <div className="col-lg-12">
                        <p className="m-0 p-0 price-pro">Batch Code </p>
                        <a href>{ResData?.batchCode}</a>
                        <hr className="m-0 pt-2 mt-2" />
                      </div>
                      <div className="col-lg-12">
                        <p className="m-0 p-0 price-pro">Manufacture Date</p>
                        <a href>{ResData?.mfgDate}</a>
                        <hr className="m-0 pt-2 mt-2" />
                      </div>
                      <div hidden={brandId != 1} className="col-lg-12">
                        <p className="m-0 p-0 price-pro">Marketed by</p>Glanbia
                        Performance Nutrition India Pvt. Ltd.
                        <hr className="m-0 pt-2 mt-2" />
                      </div>
                      {/* <p className="m-0 p-0 price-pro">Received At</p><a href>{ResData?.wareHouseId && ResData?.wareHouseId.length > 0 ? ResData?.receivedAt : ResData?.receivedDAt}</a> */}
                      {
                        // ResData?.receivedLocation ? (
                        //   <div className="col-lg-12">
                        //     <p className="m-0 p-0 price-pro">Location</p>
                        //     <a href>{`${ResData.receivedLocation}/${ResponseQRScratch.currentLocation.split('|').pop().trim()}`}</a>
                        //     <hr className="m-0 pt-2 mt-2" />
                        //   </div>
                        // ) : (
                        //   <div className="col-lg-12">
                        //     <p className="m-0 p-0 price-pro">Location</p>
                        //     <a href>{ResponseQRScratch.currentLocation.split('|').pop().trim()}</a>
                        //     <hr className="m-0 pt-2 mt-2" />
                        //   </div>
                        // )
                      }
                      {
                        // <div className="col-lg-12">
                        //   <p className="m-0 p-0 price-pro">Expiry Date</p><a href>{detail?.expDate}</a>
                        //   <hr className="p-0 m-0" />
                        // </div>
                      }
                      {
                        // <div className="col-lg-12">
                        //   <p className="m-0 p-0 price-pro">Product Description</p>
                        //   <a href>{detail?.productdesc}</a>
                        //   <hr className="p-0 m-0" />
                        // </div>
                      }

                      <div className="col-lg-12 mt-3">
                        <div className="row">
                          <div className="col-lg-12">
                            <button
                              className="mt-1 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 btn-block"
                              type="button"
                              onClick={openDialog}
                            >
                              Feedback
                            </button>
                          </div>
                        </div>
                        <Dialog
                          open={showDialog}
                          onClose={handleDialogClose}
                          className="add"
                        >
                          {/* <DialogTitle></DialogTitle> */}
                          <div className="modal-header">
                            <h5 className="modal-title adduser">
                              Add Feedback
                            </h5>
                          </div>

                          <form
                            style={{ padding: "0px" }}
                            onSubmit={handleFormSubmit}
                          >
                            <DialogContent style={{ borderRadius: "0px" }}>
                              <TextField
                                className="pl-3 pr-3"
                                margin="dense"
                                label={
                                  <span className="pl-3">
                                    User Name
                                    <span className="text-red-500">*</span>
                                  </span>
                                }
                                type="text"
                                name="Username"
                                value={feedbackData.Username}
                                onChange={handleFormChange}
                                placeholder="Enter User Name"
                                fullWidth
                                error={!!formErrors.Username}
                                helperText={formErrors.Username}
                              />
                              <TextField
                                className="pl-3 pr-3"
                                margin="dense"
                                label={
                                  <span className="pl-3">
                                    Mobile Number
                                    <span className="text-red-500">*</span>
                                  </span>
                                }
                                type="text"
                                name="MobNo"
                                value={feedbackData.MobNo}
                                onChange={handleFormChange}
                                placeholder="Enter Mobile Number"
                                fullWidth
                                error={!!formErrors.MobNo}
                                helperText={formErrors.MobNo}
                              />
                              <TextField
                                className="pl-3 pr-3"
                                margin="dense"
                                label={
                                  <span className="pl-3">
                                    Email Id
                                    <span className="text-red-500">*</span>
                                  </span>
                                }
                                type="text"
                                name="email"
                                value={feedbackData.email}
                                onChange={handleFormChange}
                                placeholder="Enter Email Id."
                                fullWidth
                                error={!!formErrors.email}
                                helperText={formErrors.email}
                              />
                              <TextField
                                className="pl-3 pr-3"
                                margin="dense"
                                label={
                                  <span className="pl-3">
                                    Feedback
                                    <span className="text-red-500">*</span>
                                  </span>
                                }
                                type="text"
                                name="REMARK"
                                value={feedbackData.REMARK}
                                onChange={handleFormChange}
                                placeholder="Enter Feedback "
                                fullWidth
                                error={!!formErrors.REMARK}
                                helperText={formErrors.REMARK}
                              />
                              <div className="row justify-content-center">
                                <div className="col-md-6">
                                  <DialogActions>
                                    <Button
                                      onClick={handleDialogClose}
                                      className="can bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                      type="button"
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      type="submit"
                                      color="primary"
                                      className="sub bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                    >
                                      Submit
                                    </Button>
                                  </DialogActions>
                                </div>
                              </div>
                            </DialogContent>
                          </form>
                        </Dialog>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div hidden={isIPLContestRegister} className="row m-2">
                <div className="col-lg-12" style={{ marginTop: "15px" }}>
                  <img
                    className="d-block img-fluid border p-3"
                    src={RCBContest}
                    alt="genuine"
                    loading="lazy"
                  />
                </div>
              </div>
              <div hidden={isIPLContestRegister} className="border m-4">
                <form onSubmit={SaveContestDetails}>
                  <div className="row ml-2 mr-2 mt-3 mb-3">
                    {questions.length > 0 &&
                      questions.map((item, index) => (
                        <>
                          <div className="col-md-12 mt-3">
                            <label className="form-label bold-text">
                              Q: {item.questionText}
                            </label>
                            {item.options.map((option, indexO) => (
                              <div className="">
                                <input
                                  className="radio-list"
                                  onChange={(e) => {
                                    if (selectedOptionIndex !== -1)
                                      questions[index].options[
                                        selectedOptionIndex
                                      ].isSelected = false;
                                    setSelectedOptionIndex(indexO);
                                    setSelectedQuestionAnswer({
                                      questionId: item.questionId,
                                      optionId: option.optionId,
                                    });
                                    const event = {
                                      target: {
                                        name: "question",
                                        value: {
                                          questionId: item.questionId,
                                          optionId: option.optionId,
                                        },
                                      },
                                    };
                                    option.isSelected = e.target.checked;
                                    handleContestFormChange(event);
                                  }}
                                  type="radio"
                                  name={item.questionId}
                                  id={option.optionId} // This should match the `htmlFor` on the label
                                  value={option.option}
                                />
                                <label
                                  className="option-list"
                                  htmlFor={option.optionId} // Use htmlFor here, matching the input's id
                                >
                                  {option.option}
                                </label>
                              </div>
                            ))}
                          </div>
                          <div className="col-md-12 mt-3">
                            <span className="text-red-500 mt-3">
                              {contestFormErrors.question}
                            </span>
                          </div>
                        </>
                      ))}
                  </div>
                  <div className="row ml-2 mr-2 mt-4">
                    <div className="col-md-12">
                      <InputLabel htmlFor="email-input">
                        <span className="bold-text">Email Address</span>
                      </InputLabel>
                      <TextField
                        focused
                        id="email-input"
                        variant="outlined"
                        margin="dense"
                        type="text"
                        name="email"
                        value={contestForm.email}
                        onChange={handleContestFormChange}
                        placeholder="Enter Email Address"
                        fullWidth
                      />
                      <span className="text-red-500">
                        {contestFormErrors.email}
                      </span>
                    </div>
                  </div>
                  <div className="contest ml-4 mr-2 mt-4">
                    <label>
                      <input
                        type="checkbox"
                        name="termsAndConditions"
                        value={tncChecked}
                        onChange={(e) => setTnCChecked(e.target.checked)}
                        required
                      />
                      I agree to the{" "}
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          openDialogTnC();
                        }}
                        target="_blank"
                      >
                        terms and conditions
                      </a>{" "}
                      of the contest.
                    </label>
                    <br></br>
                    <label>
                      <input
                        value={consentChecked}
                        onChange={(e) => setConsentChecked(e.target.checked)}
                        type="checkbox"
                        name="consent"
                        required
                      />
                      I give my consent to Glanbia to use my phone number and
                      email address to send me contest updates.
                    </label>
                    <br></br>
                  </div>
                  <div className=" ml-5 mr-5 mt-3 mb-3 genuine-product submit-button">
                    <Button
                      disabled={!tncChecked || !consentChecked}
                      type="submit"
                      className="sub text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    >
                      Submit
                    </Button>
                  </div>
                </form>
              </div>
              <Dialog
                open={showDialogTnC}
                onClose={closeDialogTnC}
                className="add"
              >
                <div className="modal-header">
                  <h5 className="modal-title adduser">Terms & Conditions</h5>
                  <div style={{ display: "inline-block" }}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        closeDialogTnC(false);
                      }}
                    >
                      &#10006;
                    </a>
                  </div>
                </div>
                <DialogContent style={{ borderRadius: "0px" }}>
                  <div className="row m-3 tnc">
                    <ul>
                      <li>
                        These terms and conditions (“Terms”) are with reference
                        to your participation in the contest to win IPL RCB
                        Couple Grand Terrace Hospitality Tickets (“Contest”).
                        The Contest is being organized by Royal Challengers
                        Sports Private Limited (“RCSPL”), the operator of the
                        Royal Challengers Bengaluru, professional cricket team
                        (“RCB”) participating in the Indian Premier League 2025
                        (“League”) in partnership with Glanbia Performance
                        Nutrition (India) Private Limited (“Glanbia”).
                        (Hereinafter, RCSPL and Glanbia shall be together
                        referred to as “Organizer”).
                      </li>
                      <li>
                        For the purpose of these Terms, “you” and “your” shall
                        mean any individual who has participated in the Contest.
                        By proceeding forward, you unconditionally and
                        unequivocally accept these Terms.
                      </li>
                      <li>
                        The Contest begins on 13th March at 00: 01 hours and
                        ends on 8th May 2025 at 24:00 hours. Entries submitted
                        outside this period will not be considered.
                      </li>
                      <li>
                        The Contest is open to legal residents of India, aged 18
                        years and above.
                      </li>
                      <li>
                        The Organizer shall not accept any responsibility
                        whatsoever for any technical failure or malfunction or
                        any other issues which may result in any entry not being
                        properly registered or received.
                      </li>
                      <li>
                        The Contest is valid only for purchases of the RCB
                        Special Gold Standard 100% Whey Double Rich Chocolate
                        2LBs and/or 5LBs Pack.
                      </li>
                      <li>
                        Winners of the Contest will be eligible to receive one
                        Grand Terrace Hospitality ticket to IPL Royal
                        Challengers Bangalore (RCB) home matches only that will
                        be played at M Chinnaswamy Stadium in Bengaluru, upon
                        purchase of one number of RCB Special Gold Standard 100%
                        Whey Double Rich Chocolate 2LBs and/or 5LBs Pack.
                      </li>
                      <li>
                        The winner of the Contest will only be eligible for a
                        free match ticket from Glanbia. The expense for
                        travelling to the match location in Bangalore;
                        accommodation and other miscellaneous expenses will be
                        borne by the winner itself.
                      </li>
                      <li>
                        Winners will have collect the tickets from Chinnaswamy
                        Stadium in Bengaluru onans the match day.
                      </li>
                      <li>
                        Organizers reserve the right to select the winners basis
                        the correct answer to the trivia submitting during
                        entries. The winners shall be selected randomly by way
                        of lottery.
                      </li>
                      <li>
                        The participants adjudged Winner(s) will be notified via
                        e-mail and/ or phone during the Contest duration.
                      </li>
                      <li>
                        If a winner does not respond within three (3) days of
                        notification, the prize may be forfeited and awarded to
                        another participant.
                      </li>
                      <li>
                        The number of winners and tickets will be determined at
                        the discretion of the Organizer.
                      </li>
                      <li>
                        The ticket(s) will be allocated based on match
                        availability.
                      </li>
                      <li>
                        The ticket(s) shall be considered cancelled in the event
                        the match is cancelled. Further, in case of such
                        cancellation, the winners would not be eligible for any
                        kind of refund for either the match ticket(s) or expense
                        borne by the winners for travel, stay and other
                        miscellaneous expenses borne for the match.
                      </li>
                      <li>
                        The tickets are non-transferable and cannot be exchanged
                        for cash or any other alternatives.
                      </li>
                      <li>
                        The Organizer reserves the right to verify the
                        authenticity of purchases and disqualify any fraudulent
                        entries. Winner(s) must provide valid identification and
                        proof of purchase of the aforementioned Glanbia
                        product(s) in order to claim the prize.
                      </li>
                      <li>
                        The Organizer reserves the right to modify, suspend, or
                        terminate the Contest at any time without prior notice.
                      </li>
                      <li>
                        The Organizer shall not be liable for any loss, injury,
                        or damage suffered as a result of participation or use
                        of the prize.
                      </li>
                      <li>
                        This Contest is governed by the laws of India, and any
                        disputes shall be subject to the exclusive jurisdiction
                        of the courts in New Delhi.
                      </li>
                    </ul>
                  </div>
                </DialogContent>
              </Dialog>
            </div>
          ) : (
            <div className="card">
              <div className="card-header genuine">
                <p className="pa-text">
                  Please scan a QR Code to proceed for Authentication
                </p>
              </div>
            </div>
          )}
        </div>
        {/* Footer Start */}
        <div
          hidden={isIPLContestRegister}
          className="footermy wow fadeIn"
          data-wow-delay="0.3s"
        >
          <div className="container copyright">
            <div className="row">
              <div className="col-md-6 text-white copyright">
                {" "}
                © {new Date().getFullYear()} Optimum Nutrition, INC{" "}
              </div>
              <div className="col-md-6 text-right copyright designedby">
                Design & Developed by{" "}
                <a
                  href="https://holostik.com/"
                  className="desinged-by"
                  target="_blank"
                >
                  Holostik India Limited
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Footer End */}
      </div>
    </>
  );
};

export default Genuine;
